import { Epic, ofType } from 'redux-observable';
import { forkJoin, of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';
import { addNotification } from '../../../actions/ui';
import {
  DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
  NotificationTypeEnum,
} from '../../../actions/ui/types';
import {
  BULK_DOWNLOAD_REPORTS_FAILURE,
  BULK_DOWNLOAD_REPORTS_REQUEST,
} from '../../../actions/types';
import {
  bulkDownloadReports,
  downloadReport,
  setReportSelection,
} from '../../../actions';
import { reportsCenterErrorCodes } from '../../../config/errorCodeMessages';

export const bulkDownloadReportsEpic: Epic = (action$, state$, { api }) =>
  action$.pipe(
    ofType(BULK_DOWNLOAD_REPORTS_REQUEST),
    switchMap((action) => {
      const downloadReportRequests = action.payload?.reportIds?.map(
        (reportId: string) =>
          api.reportsCenterService
            .downloadReport({
              logisticsPartyId: action.payload?.logisticsPartyId,
              term: action.payload?.term,
              reportType: action.payload?.reportType,
              reportId,
            })
            .pipe(
              catchError((err) =>
                of(
                  downloadReport.failure(err),
                  addNotification({
                    type: NotificationTypeEnum.ERROR,
                    action: BULK_DOWNLOAD_REPORTS_FAILURE,
                    body: err?.receivedException?.errorCode
                      ? reportsCenterErrorCodes[
                          err?.receivedException?.errorCode
                        ] ?? 'download_report_notifications.failure'
                      : 'download_report_notifications.failure',
                    timeout: DEFAULT_NOTIFICATION_CLOSE_TIMEOUT,
                  })
                )
              )
            )
      );
      return forkJoin(downloadReportRequests).pipe(
        mergeMap((response) => {
          if (response) {
            // TODO: Figure out a better way for bulk download
            response.forEach((fileDownloadDetails) => {
              if (fileDownloadDetails?.downloadUrl) {
                window.open(fileDownloadDetails?.downloadUrl, '_blank');
              }
            });
          }

          return of(bulkDownloadReports.success(), setReportSelection([]));
        })
      );
    })
  );

export default bulkDownloadReportsEpic;
